import withSuspense from './withSuspense'

export default withSuspense
